export const GET_REQUISITION_CREATE = "GET_REQUISITION_CREATE";
export const GET_REQUISITION_EDIT = "GET_REQUISITION_EDIT";
